<div
  [ngClass]="{
  'invalid-config-name': !focused && form.urlAddress.invalid && (form.urlAddress.dirty || form.urlAddress.value?.length),
  'focused-input-default': focused
 }"
  class="url-address-container global-transition">
  <label for="urlAddressForm">{{ 'view_translations.url_address' | translate }}</label>
  <form [formGroup]="urlAddressForm" class="url-address-form">
    <input
      (blur)="focused = false"
      (focus)="focused = true"
      [ngClass]="{ 'invalid-config-name': !focused && form.urlAddress.invalid && (form.urlAddress.dirty || form.urlAddress.value?.length) }"
      class="url-address-input"
      formControlName="urlAddress"
      id="url-address"
      name="urlAddress"
      placeholder="{{ ('view_translations.for_example_abbreviation' | translate ) + ' https://www.example.com/deeplink-url-example' }}"
      type="text" />
    <div class="info-icon">
      <div class="tooltip-container">
        <div class="tooltip-inner-container">
          <div
            class="tooltip-button tool-tip"
            container="body"
            ngbTooltip="{{'postback_api_link' | t}}"
            placement="bottom"
            tooltipClass="my-configurations-tooltip">
            <h4>
              <nb-icon icon="info" pack="icomoon"></nb-icon>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!focused && form.urlAddress.invalid && (form.urlAddress.dirty || form.urlAddress.value?.length)" class="error-text">
  <small *ngIf="form.urlAddress.errors?.required" class="form-text text-danger">*{{ 'view_translations.this_field_is_required' | translate }}</small>
  <small *ngIf="form.urlAddress.errors?.urlInvalid" class="form-text text-danger">*{{ 'view_translations.incorrect_url_address' | translate }}</small>
</div>
